export const SceneryPictures = [
    {
        "id": 1,
        "title" : "New York",
        "description" : "拍摄于纽约 Photographed in New York",
        "firstPic" : "https://files.seeusercontent.com/2026/06/27/asP3/ecb69407_KUmpbDz72SAIZdR.jpg",
        "pics" : [ {
          "src" : "https://files.seeusercontent.com/2026/06/27/T6wy/90486cae_Whsejakbv6PCl74.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/asP3/ecb69407_KUmpbDz72SAIZdR.jpg",
          "description" : ""
        } ]
      },
  {
    "id": 2,
    "title": "Big Ben",
    "description": "",
    "firstPic": "https://files.seeusercontent.com/2026/06/27/S3bi/906da0b1_DSC02851-5-1.jpg",
    "pics": [
      {
        "src": "https://files.seeusercontent.com/2026/06/27/S3bi/906da0b1_DSC02851-5-1.jpg",
        "description": ""
      }
    ]
  },
  {
    "id": 3,
    "title": "North Ireland",
    "description": "",
    "firstPic": "https://files.seeusercontent.com/2026/06/27/1tCa/aeeef49a_IMG_1792.jpg",
    "pics": [
      {
        "src": "https://files.seeusercontent.com/2026/06/27/1tCa/aeeef49a_IMG_1792.jpg",
        "description": ""
      }
    ]
  },
  {
    "id": 4,
    "title": "Blue Cave",
    "description": "",
    "firstPic": "https://files.seeusercontent.com/2026/06/27/4cvG/a66cea9f_IMG_1844-5-1.jpg",
    "pics": [
      {
        "src": "https://files.seeusercontent.com/2026/06/27/4cvG/a66cea9f_IMG_1844-5-1.jpg",
        "description": ""
      }
    ]
  },
  {
    "id": 5,
    "title": "Montenegro",
    "description": "",
    "firstPic": "https://files.seeusercontent.com/2026/06/27/2dOt/9573f8b8_IMG_1957-5-6.jpg",
    "pics": [
      {
        "src": "https://files.seeusercontent.com/2026/06/27/2dOt/9573f8b8_IMG_1957-5-6.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/06/27/f9Cp/205628e0_IMG_1996-4-2.jpg",
        "description": ""
      }
    ]
  },
  {
    "id": 6,
    "title": "Christmas",
    "description": "",
    "firstPic": "https://files.seeusercontent.com/2026/06/27/y2cT/1a3bb830_DSC09746-5-1.jpg",
    "pics": [
      {
        "src": "https://files.seeusercontent.com/2026/06/27/y2cT/1a3bb830_DSC09746-5-1.jpg",
        "description": ""
      }
    ]
  },
  {
    "id": 7,
    "title": "Fall",
    "description": "",
    "firstPic": "https://files.seeusercontent.com/2026/06/27/H9rh/9c4ab75c_DSC00471-5-5.jpg",
    "pics": [
      {
        "src": "https://files.seeusercontent.com/2026/06/27/H9rh/9c4ab75c_DSC00471-5-5.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/06/27/axI5/37f8129a_DSC00475-5-2.jpg",
        "description": ""
      }
    ]
  },
  {
    "id": 8,
    "title": "Big Ben and London Eye",
    "description": "",
    "firstPic": "https://files.seeusercontent.com/2026/08/04/Ga8s/cover.jpg",
    "pics": [
      {
        "src": "https://files.seeusercontent.com/2026/08/04/Ga8s/cover.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/5Hdg/DSC01039-1.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/04/7gCg/DSC01040-1.jpg",
        "description": ""
      }
    ]
  },
  {
    "id": 9,
    "title": "",
    "description": "",
    "firstPic": "https://files.seeusercontent.com/2026/08/31/9Rll/DSC00289-5-1.jpg",
    "pics": [
      {
        "src": "https://files.seeusercontent.com/2026/08/31/9Rll/DSC00289-5-1.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/08/31/Bs3d/DSC00293-5-2.jpg",
        "description": ""
      }
    ]
  }
];
